function initScrollToTop() {
  const button = document.querySelector('.scroll-to-top');
  if (!button) return;

  const showThreshold = 200;
  const scrollDelta = 6;

  let lastScrollY = window.scrollY;

  const setVisible = (visible) => {
    button.hidden = !visible;
  };

  const updateVisibility = () => {
    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;

    if (scrollY <= showThreshold) {
      setVisible(false);
    } else if (delta > scrollDelta) {
      setVisible(false);
    } else if (delta < -scrollDelta) {
      setVisible(true);
    }

    lastScrollY = scrollY;
  };

  button.addEventListener('click', () => {
    setVisible(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener(
    'scroll',
    () => requestAnimationFrame(updateVisibility),
    { passive: true }
  );

  setVisible(false);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollToTop);
} else {
  initScrollToTop();
}
